import instObj from '@/backend/axios-instances'

const resource = "/cutsheet"
const instance = instObj.baseInstance

export default {
  post(data) {
    return instance.post(resource, data);
  },
  get(cutSheetId, parameters) {
    return instance.get(`${resource}/${cutSheetId}`, { params: parameters });
  },
  put(cutSheetId, data) {
    return instance.put(`${resource}/${cutSheetId}`, data);
  },
  delete(cutSheetId) {
    return instance.delete(`${resource}/${cutSheetId}`);
  },
  attach(cutSheetId, data) {
    return instance.post(`${resource}/${cutSheetId}/attachment`, data);
  }
}
